import { forwardRef, useImperativeHandle, useRef } from "react";
import { useState, useEffect, memo } from "react";
import StandardAttribute_Actions from "../../../Actions/StandardAttribute_Actions";
import standardAttributeStores from "../../../Stores/StandardAttributeStores";
import StandardAttributeConstants from "../../../Constants/StandardAttributeConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";

const OptionsListPopUp = forwardRef((props, ref) => {
  const [existingOptionsList, setExistingOptionsList] = useState("");
  const [currentOptionsList, setCurrentOptionsList] = useState("");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const currentAttrId = useRef(null);
  const { localization } = useLanguageContext();

  useImperativeHandle(ref, () => ({
    handleLoad(equGrpId, attributeData) {
      setGlobalSpinner(true);
      StandardAttribute_Actions.getOptionsListForStandardAttr(
        equGrpId,
        attributeData.attributeID,
      );
      currentAttrId.current = attributeData.attributeID;
    },
  }));

  useEffect(() => {
    function getStandardAttrOptionSuccess() {
      const res = standardAttributeStores.getStandardAttributeOptions();
      if (res) {
        setExistingOptionsList(res.options);
      } else {
        setExistingOptionsList("");
      }
      setGlobalSpinner(false);
    }

    function getStandardAttrOptionFailure() {
      const res = standardAttributeStores.getStandardAttributeOptions();
      setGlobalSpinner(false);
    }

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_STANDARD_ATTRIBUTE_OPTIONS_SUCCESS,
      getStandardAttrOptionSuccess,
    );

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_STANDARD_ATTRIBUTE_OPTIONS_FAILURE,
      getStandardAttrOptionFailure,
    );

    return () => {
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_STANDARD_ATTRIBUTE_OPTIONS_SUCCESS,
        getStandardAttrOptionSuccess,
      );

      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_STANDARD_ATTRIBUTE_OPTIONS_FAILURE,
        getStandardAttrOptionFailure,
      );
    };
  }, []);

  const AddUpdateOptions = () => {
    props.handleOptionsListPopUpSaveCallback(
      currentAttrId.current,
      currentOptionsList,
    );
    setCurrentOptionsList("");
    commonUtils.hideModalPopUp("optionsListPopUpClose");
  };

  const handleChange = (val) => {
    setCurrentOptionsList(val);
  };

  return (
    <div
      className="modal fade"
      id="optionsListPopUp"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="optionsListPopUp"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="custom-modal-medium modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="optionsListPopUpTitle">
              {localization.optionListOverwriteEquGrp}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="optionsListPopUpClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <form id="optionsListPopUpForm" autoComplete="off">
              <div className="form-outline mb-4">
                <div className="row">
                  <div className="col-6">
                    <label className="form-label" htmlFor="equipment">
                      <b>{localization.existingOptionList}</b>
                    </label>
                    <div className="exisitngOptionListDiv">
                      <span>{existingOptionsList}</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-outline mb-4">
                      <label className="form-label" htmlFor="optionsList">
                        <b>{localization.enterNewOptions}</b>
                      </label>
                      <div className="newOptionListDiv">
                        <textarea
                          id="optionsList"
                          name="optionsList"
                          className="form-control"
                          placeholder={localization.enterOptionsLike}
                          value={currentOptionsList}
                          onChange={(e) => {
                            handleChange(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <div className="form-group marProp">
              <button
                type="button"
                className="btn btn-primary mb-4"
                onClick={AddUpdateOptions}
              >
                {localization.ok}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default memo(OptionsListPopUp);
